// extracted by mini-css-extract-plugin
module.exports = {"link":"_2QtACk","heading":"y9lqm7","wrap":"_27e7tW"};